module.exports = __webpack_public_path__ + "media/audios/kid/lesson_5/audio20-96bba89e8028bda5742dd62301cb175a.m4a";